import { render, staticRenderFns } from "./HomeJoin.vue?vue&type=template&id=579d49a2&scoped=true&"
import script from "./HomeJoin.vue?vue&type=script&lang=js&"
export * from "./HomeJoin.vue?vue&type=script&lang=js&"
import style0 from "./HomeJoin.vue?vue&type=style&index=0&id=579d49a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579d49a2",
  null
  
)

export default component.exports